module.exports = __webpack_public_path__ + "img/Lavish2.eb71ebfc.jpg";